// src/pages/Dashboard.js
import React from "react";
import { Box, Typography } from "@mui/material";

const ImportList = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>

      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>

      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>

      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
      <Typography variant="h4" gutterBottom>
        นำเข้าข้อมูลรายการ
      </Typography>
    </Box>
  );
};

export default ImportList;
